import { useEffect, useRef, useState } from 'react'
import './Attempts.css'

import { auth } from '../../../../Firebase/InitFirebase';
import { getUsersSubmissionsForProblem } from '../../../../Firebase/FireStore';
import { getLanguageByID } from '../../../../Data/ProblemsMethod';
import Editor from '@monaco-editor/react';
import CodeBlock from './CodeBlock';



export default function Attempts({problemID, previous_attempts, set_previous_attempts}){


    const [index_of_selected_submission, set_index_of_selected_submission] = useState(-1);
    const selected_submission_ref = useRef(null)
    const code_of_selected_submission_ref = useRef(null)
    useEffect(() => {
        async function loadAttempts(){
            if (previous_attempts.length > 0) return; 
            console.log("[DB HIT]")
            const currUser =  auth.currentUser?.uid;
            if (currUser != null) {
                try{
                    const querySnapshot = await getUsersSubmissionsForProblem(problemID, currUser);
                    let attempts = [];
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        attempts.push({
                            LanguageID : doc.data().LanguageID,
                            passedProblem : doc.data().passedProblem,
                            IDEText : doc.data().IDEText,
                            submissionTime : doc.data().submissionTime
                        })
                    });
                    console.log("Previous Attempts: ", attempts)
                    set_previous_attempts(attempts)

                }catch(err){
                    console.log("[ERROR] Failed to get previous submissions from db", err)
                }
            }else{
                console.log("Curr user NULL")
            }
        }
        loadAttempts()
    },[]);



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selected_submission_ref.current && !selected_submission_ref.current.contains(event.target)) { // If you click on either the code or the tag
                if(code_of_selected_submission_ref.current){ // If user clicks on the code, dont close the submission
                    if(!code_of_selected_submission_ref.current.contains(event.target)){
                        set_index_of_selected_submission(-1)
                    }
                }else{
                    set_index_of_selected_submission(-1)
                }
            }
           
        };
        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);

    let attempts = previous_attempts.map((obj, idx) => {
        const passed = obj.passedProblem;
        const submissionTime = obj.submissionTime;
        const isEven = idx%2==0;
        const language = getLanguageByID(obj.LanguageID)
        return (
            <div className='outmost-attempts-wrapper'>           
            <div 
                ref={idx === index_of_selected_submission ? selected_submission_ref : null} // ref only on the open block
                onClick = {() => {
                    if(index_of_selected_submission == idx) set_index_of_selected_submission(-1)
                    else set_index_of_selected_submission(idx)
                }}
                className = {
                            isEven ?
                                (passed ? "attempt passed even-prev-submission" : "attempt failed even-prev-submission") :
                                (passed ? "attempt passed odd-prev-submission" : "attempt failed odd-prev-submission") 
                            }
            >
                <div className='submission-number'>
                    {idx + 1}
                </div>
                <div className='status-spacing'>
                    
                    <div className={
                        passed ? "accepted-status passed": "accepted-status failed"
                    }>
                        {passed ? "Accepted" : "Failed"}
                    </div>
                </div>
                <div className='submission-language'>
                    {language}
                </div>
                <div className='time-of-submission'>
                    {submissionTime?.toDate().toLocaleDateString()}
                </div>
            </div>
           
            <div className='submission-code'
                ref={idx === index_of_selected_submission ? code_of_selected_submission_ref : null} 
            >
                {
                    (index_of_selected_submission === idx ) && 
                    <div className='code-block-wrapper'>
                        <CodeBlock language={language} code={obj.IDEText}/>
                    </div>
                }
            </div>
            </div>

        );
    })

    return(
        <div className="attempts-wrapper">
           {attempts}
        </div>
    )
}